import { openDB, type IDBPDatabase } from 'idb';
import { MemoryProvider, type StorageProvider, type UserProgress } from './StorageProvider';

const DB_NAME = 'autoacademy';
const STORE = 'progress';
const KEY = 'main';

export class IndexedDBProvider implements StorageProvider {
  private db: Promise<IDBPDatabase> | null = null;

  private open(): Promise<IDBPDatabase> {
    if (!this.db) {
      this.db = openDB(DB_NAME, 1, {
        upgrade(db) {
          if (!db.objectStoreNames.contains(STORE)) db.createObjectStore(STORE);
        },
      });
    }
    return this.db;
  }

  async load(): Promise<UserProgress | null> {
    const db = await this.open();
    const value = (await db.get(STORE, KEY)) as UserProgress | undefined;
    return value ?? null;
  }

  async save(progress: UserProgress): Promise<void> {
    const db = await this.open();
    await db.put(STORE, progress, KEY);
  }

  async clear(): Promise<void> {
    const db = await this.open();
    await db.delete(STORE, KEY);
  }
}

export function createStorageProvider(): StorageProvider {
  // Entorno sin IndexedDB (tests/SSR): memoria
  if (typeof indexedDB === 'undefined') return new MemoryProvider();
  return new IndexedDBProvider();
}
